"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var parseQueryParameters = function parseQueryParameters(url) {
  var regex = /[?&]([^=#]+)=([^&#]*)/g;
  var params = {};
  var match;
  while (match = regex.exec(url)) {
    params[match[1]] = match[2];
  }
  return params;
};
var _default = parseQueryParameters;
exports["default"] = _default;